<template>
	<div class="centerWidth">
		<div class="gaokao-nav">
			<span @click="goMyCenter">个人中心 ></span>
			<span @click="goBack">学习时间管理测评 ></span>
			<span>开始测试</span>
		</div>
		<section class="gaokao-content">
			<div class="my-title">学习时间管理测评</div>
			<article class="testTwo-con">
				<div class="testTwo-list" v-for="(item,index) in list" :key="index">
					<p class="test-ctxt">{{item.topic}}</p>
					<ul class="testTwo-ul">
						<li v-for="(t,index) in item.option" :key="index">
							<input type="radio" name="sel" />
							<p>{{t.txt}}</p>
						</li>
					</ul>
				</div>
			</article>
			<div class="test-btn">
				<button class="gaokao-btn" @click="subPop()">提交</button>
			</div>
		</section>
		<!-- 提交弹窗 -->
		<div class="popup" v-show="isSub">
			<div class="pop-width animated fadeIn">
				<div class="submit-bg"><img src="../../../image/pop-del.png" @click="subDel" /></div>
				<p class="submit-tit">提交成功</p>
				<p class="submit-txt">系统将自动跳转[我的报告]，跳转后点击[查看报告]</p>
				<p class="submit-txt">马上了解最适合你科目组合吧!</p>
				<button class="gaokao-btn pop-btn" @click="goReport">确定</button>
			</div>
		</div>
		<!-- 5.30 -->
		<div class="ptpopupTc flexCenter" v-if="isJiaIng">
			<div class="ptpotxt">
				<div class="ptadiva" id="myChartYuan"></div>
				<p>请稍等,正在为您生成报告...</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			isJiaIng: false,
			sel: '',
			// 弹窗
			isSub: false,
			list: [
				{
					topic: '1/44我认为“一寸光阴一寸金”这句话是正确的',
					option: [
						{
							txt: '很符合自己的情况'
						}, {
							txt: '比较符合自己的情况'
						}, {
							txt: '一般般'
						}, {
							txt: '较不符合自 己的情况'
						}, {
							txt: '很不符合自己的情况'
						}
					]
				}, {
					topic: '2/44我通常把每天的活动安排成一个日程表',
					option: [
						{
							txt: '很符合自己的情况'
						}, {
							txt: '比较符合自己的情况'
						}, {
							txt: '一般般'
						}, {
							txt: '较不符合自 己的情况'
						}, {
							txt: '很不符合自己的情况'
						}
					]
				}, {
					topic: '3/44“时间就是效益”这句话是正确的',
					option: [
						{
							txt: '很符合自己的情况'
						}, {
							txt: '比较符合自己的情况'
						}, {
							txt: '一般般'
						}, {
							txt: '较不符合自 己的情况'
						}, {
							txt: '很不符合自己的情况'
						}
					]
				}, {
					topic: '4/44我每天都给自己指定一个学习目标',
					option: [
						{
							txt: '很符合自己的情况'
						}, {
							txt: '比较符合自己的情况'
						}, {
							txt: '一般般'
						}, {
							txt: '较不符合自 己的情况'
						}, {
							txt: '很不符合自己的情况'
						}
					]
				}, {
					topic: '5/44无论做什么事情，我优先考虑的是时间因素',
					option: [
						{
							txt: '很符合自己的情况'
						}, {
							txt: '比较符合自己的情况'
						}, {
							txt: '一般般'
						}, {
							txt: '较不符合自 己的情况'
						}, {
							txt: '很不符合自己的情况'
						}
					]
				}
			]
		};
	},
	mounted() {
		this.drawLineB();
	},
	methods: {
		drawLineB() {
			const myChart = this.$echarts.init(document.getElementById('myChartYuan'));
			myChart.setOption({
				color: ['#feb9a7', '#3171ff00'],
				tooltip: {
					trigger: 'item',
					show: false
				},
				graphic: {
					type: 'text',
					left: 'center',
					top: 'center',
					style: {
						text: '75%',
						textAlign: 'center',
						fill: '#7ac8fd',
						fontSize: 24
					}
				},
				legend: {
					top: '0%',
					left: 'center'
				},
				series: [{
					type: 'pie',
					radius: ['55%', '65%'],
					avoidLabelOverlap: false,
					hoverAnimation: false,
					label: {
						show: false,
						position: 'center'
					},
					emphasis: {
						label: {
							show: true,
							fontSize: '40',
							fontWeight: 'bold'
						}
					},
					labelLine: {
						show: false
					},
					data: [{
						value: 1048,
						name: ''
					}, {
						value: 735,
						name: ''
					}]
				}]
			});
		},
		// 个人中心
		goMyCenter() {
			this.$router.push('/myIndex');
		},
		// 返回上一级
		goBack() {
			this.$router.go(-1);
		},
		// 我的报告
		goReport() {
			this.$router.push('/report');
		},
		// 弹窗
		subPop() {
			var that = this;
			that.isSub = true;
			setTimeout(function() {
				that.goReport();
			}, 5000);
		},
		subDel() {
			var that = this;
			that.isSub = false;
		}
	}
};
</script>

<style scoped>
.gaokao-nav {
	width: 100%;
	display: flex;
	align-items: center;
	padding: 20px 0;
}
.gaokao-nav span {
	font-size: 15px;
	color: #333;
}
.gaokao-nav span:last-child {
	color: #333;
}
/* gaokao-content */
.gaokao-content {
	padding: 0 20px;
	width: 100%;
	height: auto;
	overflow: hidden;
	background-color: #fff;
	margin-bottom: 25px;
}

/* testTwo-con */
.testTwo-con {
	width: 100%;
	height: auto;
	overflow: hidden;
	margin-top: 40px;
}
.testTwo-list {
	width: 100%;
	height: auto;
}
.test-ctxt {
	font-size: 15px;
	color: #333;
	margin-bottom: 25px;
}
.testTwo-ul {
	padding: 0 30px;
	height: auto;
	overflow: hidden;
}
.testTwo-ul li {
	width: 100%;
	display: flex;
	align-items: center;
	margin-bottom: 25px;
}
.testTwo-ul li input {
	margin-right: 15px;
}
.testTwo-ul li p {
	font-size: 15px;
	color: #333;
}
.test-btn {
	display: flex;
	align-items: center;
	justify-content: center;
}
.test-btn button {
	margin-left: 20px;
	margin-right: 20px;
}

</style>
